// src/pages/hotelMealPlans/HotelMealPlans.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import HotelMealPlansTable from "../../components/hotelMealPlans/HotelMealPlansTable";

const HotelMealPlans = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            {/* data table Hotel Meal Plans */}
            <HotelMealPlansTable />
        </WrapperSection>
    );
};

export default HotelMealPlans;
